module.exports = __webpack_public_path__ + "img/shebei5.a04dff53.png";